import { registerCondition } from 'core/forms';

const doesNotMatchType = ({ fieldKey, model }) => ({
  condition: { error: 'This field key does not match the value of the type field' },
  hasCondition: fieldKey !== model.type,
});

registerCondition('doesNotMatchType', doesNotMatchType);

export default doesNotMatchType;
